import { render } from "./M365LogoWithSettings.vue?vue&type=template&id=a8f1ae72"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__